import React from 'react';
import './formHelpers.scss';

/**
 * Shared small form/UI render helpers.
 *
 * Add new reusable helpers here (e.g. field hints, labeled wrappers) rather than
 * duplicating them across sections. Each helper is a named export so callers can
 * import only what they need: `import { requiredMark } from 'src/components/shared/formHelpers'`.
 */

/** Red asterisk marking a required form field. */
export const requiredMark = () => <span className="required-mark"> *</span>;

/** "* Required field" hint, typically placed in a form's actions row. */
export const requiredFieldHint = () => (
    <span className="required-hint">{requiredMark()} Required field</span>
);
